import { ClientInferResponseBody } from "@ts-rest/core";

import { api, contract } from "#app/http/api";

export type SimilarPartFeedbackDto = ClientInferResponseBody<
  typeof contract.feedback.getUserSimilarPartFeedbacks
>[number];

export const fetchSimilarPartFeedbacks = async (
  sourcePartId: string | undefined,
): Promise<SimilarPartFeedbackDto[]> => {
  if (!sourcePartId) {
    throw new Error("Source part ID is required");
  }

  const response = await api.feedback.getUserSimilarPartFeedbacks.query({
    query: { sourcePartId },
  });

  if (response.status === 200) {
    return response.body;
  }

  throw new Error("Failed to fetch similar part feedbacks");
};
